import React, { useState, useEffect, useRef } from 'react';
import { classNames } from 'primereact/utils';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import AppTopbar from './AppTopbar';
import AppFooter from './AppFooter';
import AppConfig from './AppConfig';
import AppRightMenu from './AppRightMenu';
import AppBreadcrumb from './AppBreadcrumb';
import AppMenu from './AppMenu';
import Dashboard from './components/Dashboard';
import Login from './pages/Login';
import MerchantList from './pages/Merchant/Merchant List/MerchantList';
import PrimeReact from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';
import CollectionLedger from './pages/Ledger/CollectionLedger';
import MerchantFeeReport from './pages/Merchant/Merchant Fee Report/MerchantFeeReport';
import WithdrawalReport from './pages/Merchant/Withdrawal Report/WithdrawalReport';
import PageList from './pages/Management/Page/PageList';
import Blog from './pages/Management/Blog/Blog';
import BillerList from './pages/Bill/BillerList';
import BillerPayment from './pages/Bill/BillerPayment';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import MerchantWithdrawal from './pages/Merchant/Merchant Withdrawal/MerchantWithdrawal';
import MerchantWallet from './pages/Merchant/Merchant Wallet/MerchantWallet';
import MerchantMock from './pages/Merchant/Merchant Mock/MerchantMock';
import MerchantWalletRequest from './pages/Merchant/Merchant Wallet Request/MerchantWalletRequest';
import MerchantFees from './pages/Merchant/Merchant Fees/MerchantFees';
import GatewayList from './pages/Gateway/GatewayList';
import ManageVendors from './pages/Vendor/ManageVendor';
import ManageEPOS from './pages/EPOS/ManageEPOS';
import ManageLanguages from './pages/Languages/ManageLanguages';
import ManageWhiteList from './pages/WhiteList/ManageWhiteList';
import ManageAccounts from './pages/AccountApproval/ManageAccounts';
import BankList from './pages/Bank/BankList';
import CurrencyList from './pages/Currency/CurrencyList';
import Roles from './pages/Roles/Roles';
import MerchantReports from './pages/Reports/Merchantreports';
import InvoiceReports from './pages/Reports/InvoiceReports';
import Users from './pages/Users/Users';
import LoginScreen from './pages/Login';
import Customers from './pages/Customers/Customers';
import InvoiceManagement from './pages/InvoiceManagement/InvoiceManagement';
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import LoadingOverlay from 'react-loading-overlay';
import AddMerchant from './pages/Merchant/Merchant List/AddMerchant';
import MerchantApprovals from './pages/Merchant/MerchantApprovals/MerchantApproval';
import MerchantDrafts from './pages/Merchant/MerchantDrafts/MerchantDrafts';
import EditMerchant from './pages/Merchant/Merchant List/EditMerchant';
import Tickets from './pages/Tickets/Tickets';
import ViewTicket from './pages/Tickets/ViewTicket';
import EditDraftMerchant from './pages/Merchant/MerchantDrafts/EditDraftMerchant';
import ViewDraftMerchant from './pages/Merchant/MerchantDrafts/ViewDraftMerchant';
import ViewMerchant from './pages/Merchant/Merchant List/ViewMerchant';
import EditMerchantApproval from './pages/Merchant/MerchantApprovals/EditMerchantApproval';
import ViewMerchantApproval from './pages/Merchant/MerchantApprovals/ViewMerchantApproval';
import EditTicket from './pages/Tickets/EditTicket';
import MerchantModule from './pages/MerchantModuleManagement/MerchantModule';
import AdminModule from './pages/AdminModuleManagement/AdminModule';
import AddRole from './pages/Roles/AddRole';
import ViewRole from './pages/Roles/ViewRole';
import EditRole from './pages/Roles/EditRole';
import { getPermissionsOfPages } from './utilities/PagePermissioms';
import { pagePermissionsSlice } from './redux/slices/pagePermissionsSlice';
import MerchantTransactionReport from './pages/MerchantTransactionReports/MerchantTransactionReports';
import BlackListDialog from './components/BlackListeDialog';
import BlacklistMerchant from './pages/Merchant/Blacklist Merchant/BlacklistMerchant';
import ForgetPassword from './pages/ForgetPassword';
import Profile from './pages/Profile/Profile';

const App = (props) => {
    const [rightMenuActive, setRightMenuActive] = useState(false);
    const [configActive, setConfigActive] = useState(false);
    const [menuMode, setMenuMode] = useState('sidebar');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [ripple, setRipple] = useState(true);
    const [sidebarStatic, setSidebarStatic] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const [topbarMenuActive, setTopbarMenuActive] = useState(false);
    const [sidebarActive, setSidebarActive] = useState(false);
    const [pinActive, setPinActive] = useState(false);
    const [activeInlineProfile, setActiveInlineProfile] = useState(false);
    const [resetActiveIndex, setResetActiveIndex] = useState(null);
    const [path, setPath] = useState(null);
    const [navMenu, setNavMenu] = useState(null);
    const copyTooltipRef = useRef();
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoading = useSelector((state) => state?.utilitySlice?.isLoading);

    PrimeReact.ripple = true;

    const user = JSON.parse(localStorage.getItem('adminUser'));

    useEffect(() => {
        if (user && !navMenu) {
            const menu = user?.data?.permissions.map((module) => ({
                label: module.ModuleName,
                icon: module.ModuleIcon,
                to: module.ModulePath,
                insertAllowed: module.Create ? 'Y' : 'N',
                viewAllowed: module.View ? 'Y' : 'N',
                updateAllowed: module.Edit ? 'Y' : 'N',
                deleteAllowed: module.Delete ? 'Y' : 'N'
            }));
            setNavMenu(menu);
        }
    }, [user]);

    useEffect(() => {
        if (path && navMenu) {
            if (path !== '/') {
                const findingMainMenu = navMenu?.filter((mainItem) => mainItem?.to?.toLowerCase() === path?.toLowerCase());
                const finding = findingMainMenu?.length > 0 || path?.toLowerCase()?.includes('add') || path?.toLowerCase()?.includes('edit') || path?.toLowerCase()?.includes('view') || path?.toLowerCase()?.includes('profile') ? 'done' : '';
                if (finding !== 'done') {
                    navigate('/');
                }
            } else if (user) {
                navigate('/');
            }

            dispatch(pagePermissionsSlice({ permissions: getPermissionsOfPages(navMenu, path) }));
        }
    }, [navMenu, path]);

    useEffect(() => {
        setPath(window.location.href?.split('/#')?.pop());
    }, [window.location.href]); // eslint-disable-line react-hooks/exhaustive-deps

    // const menu = [
    //     {
    //         label: 'Dashboard',
    //         icon: 'pi pi-home',
    //         to: '/'
    //     },
    //     {
    //         label: 'System Users',
    //         icon: 'pi pi-users', // updated icon
    //         to: '/users'
    //     },
    //     {
    //         label: 'Roles and Rights',
    //         icon: 'pi pi-id-card', // updated icon
    //         to: '/roles-permissions'
    //     },

    //     {
    //         label: 'Invoice Management',
    //         icon: 'pi pi-print', // updated icon
    //         to: '/invoiceManagement'
    //     },
    //     {
    //         label: 'Payment Gateway',
    //         icon: 'pi pi-server',
    //         to: '/gateway-list'
    //     },
    //     {
    //         label: 'Merchant Module Management',
    //         icon: 'pi pi-server',
    //         to: '/merchant-module-management'
    //     },
    //     {
    //         label: 'Admin Module Management',
    //         icon: 'pi pi-server',
    //         to: '/admin-module-management'
    //     },
    //     {
    //         label: 'Merchants',
    //         icon: 'pi pi-briefcase', // updated icon
    //         items: [
    //             {
    //                 label: 'Merchant List',
    //                 icon: 'pi pi-list',
    //                 to: '/merchant-list'
    //             },
    //             {
    //                 label: 'Merchant Approval',
    //                 icon: 'pi pi-list',
    //                 to: '/merchant-approval-list'
    //             },
    //             {
    //                 label: 'Draft Merchants',
    //                 icon: 'pi pi-list',
    //                 to: '/draft-merchant-list'
    //             },

    //             {
    //                 label: 'Merchant Withdrawal Request',
    //                 icon: 'pi pi-wallet',
    //                 to: '/merchant-withdrawal-request'
    //             },
    //             {
    //                 label: 'Merchant Wallet',
    //                 icon: 'pi pi-credit-card',
    //                 to: '/merchant-wallet'
    //             },
    //             {
    //                 label: 'Merchant Mock',
    //                 icon: 'pi pi-clone',
    //                 to: '/merchant-mock'
    //             },
    //             {
    //                 label: 'Merchant Wallet Request',
    //                 icon: 'pi pi-inbox',
    //                 to: '/merchant-wallet-request'
    //             },
    //             {
    //                 label: 'Merchant Fees',
    //                 icon: 'pi pi-percentage',
    //                 to: '/merchant-fees'
    //             },
    //             {
    //                 label: 'Merchant Fee Report',
    //                 icon: 'pi pi-chart-bar',
    //                 to: '/merchant-fee-report'
    //             },
    //             {
    //                 label: 'Withdrawal Report',
    //                 icon: 'pi pi-file-excel',
    //                 to: '/withdrawal-report'
    //             }
    //         ]
    //     },
    //     {
    //         label: 'Tickets',
    //         icon: 'pi pi-users', // updated icon
    //         to: '/tickets'
    //     },
    //     {
    //         label: 'Bank',
    //         icon: 'pi pi-money-bill', // updated icon
    //         to: '/bank-list'

    //         // items: [
    //         //     {
    //         //         label: 'Bank List',
    //         //         icon: 'pi pi-table',
    //         //         to: '/bank-list'
    //         //     },
    //         //     {
    //         //         label: 'Bank Request',
    //         //         icon: 'pi pi-inbox', // updated icon
    //         //         to: '/bank-request'
    //         //     }
    //         // ]
    //     },
    //     {
    //         label: 'Management',
    //         icon: 'pi pi-cog', // updated icon
    //         items: [
    //             // {
    //             //     label: 'Gateway List',
    //             //     icon: 'pi pi-server',
    //             //     to: '/gateway-list'
    //             // },
    //             {
    //                 label: 'Page List',
    //                 icon: 'pi pi-file',
    //                 to: '/page-list'
    //             },
    //             {
    //                 label: 'Blog',
    //                 icon: 'pi pi-book', // updated icon
    //                 to: '/blog'
    //             }
    //         ]
    //     },
    //     {
    //         label: 'Ledger',
    //         icon: 'pi pi-book',
    //         items: [
    //             {
    //                 label: 'Collection Ledger',
    //                 icon: 'pi pi-table',
    //                 to: '/collection-ledger'
    //             }
    //         ]
    //     },
    //     {
    //         label: 'Bill',
    //         icon: 'pi pi-book',
    //         items: [
    //             {
    //                 label: 'Biller List',
    //                 icon: 'pi pi-list',
    //                 to: '/biller-list'
    //             },
    //             {
    //                 label: 'Biller Payment',
    //                 icon: 'pi pi-credit-card',
    //                 to: '/biller-payment'
    //             }
    //         ]
    //     },
    //     {
    //         label: 'Vendor',
    //         icon: 'pi pi-briefcase', // updated icon
    //         to: '/vendor-list'
    //     },
    //     {
    //         label: 'EPOS',
    //         icon: 'pi pi-desktop', // updated icon
    //         to: '/epos-list'
    //     },
    //     {
    //         label: 'Language',
    //         icon: 'pi pi-globe', // updated icon
    //         to: '/language-list'
    //     },
    //     {
    //         label: 'WhiteList',
    //         icon: 'pi pi-check-square', // updated icon
    //         to: '/whitelist'
    //     },
    //     {
    //         label: 'Account Approval',
    //         icon: 'pi pi-user-plus', // updated icon
    //         to: '/manage-accounts'
    //     },

    //     {
    //         label: 'Currency',
    //         icon: 'pi pi-dollar', // updated icon
    //         items: [
    //             {
    //                 label: 'Currency List',
    //                 icon: 'pi pi-table',
    //                 to: '/currency-list'
    //             }
    //         ]
    //     },

    //     {
    //         label: 'Reports',
    //         icon: 'pi pi-chart-line', // updated icon
    //         items: [
    //             {
    //                 label: 'Merchant Reports',
    //                 icon: 'pi pi-table',
    //                 to: '/merchant-reports'
    //             },
    //             {
    //                 label: 'Invoice Reports',
    //                 icon: 'pi pi-table',
    //                 to: '/invoice-reports'
    //             }
    //         ]
    //     }
    // ];

    // const routes = [{ parent: 'Dashboard', label: 'Sales Dashboard' }, { label: 'Users' }];

    let rightMenuClick;
    let configClick;
    let menuClick;
    let searchClick = false;
    let topbarItemClick;

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    useEffect(() => {
        setResetActiveIndex(true);
        setMenuActive(false);
    }, [menuMode]);

    const onDocumentClick = () => {
        if (!searchClick && searchActive) {
            onSearchHide();
        }

        if (!topbarItemClick) {
            setTopbarMenuActive(false);
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
                setResetActiveIndex(true);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                setOverlayMenuActive(false);
                setStaticMenuMobileActive(false);
            }

            hideOverlayMenu();
            unblockBodyScroll();
        }

        if (!rightMenuClick) {
            setRightMenuActive(false);
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        topbarItemClick = false;
        menuClick = false;
        configClick = false;
        rightMenuClick = false;
        searchClick = false;
    };

    const onSearchHide = () => {
        setSearchActive(false);
        searchClick = false;
    };

    const onMenuModeChange = (menuMode) => {
        setMenuMode(menuMode);
        setOverlayMenuActive(false);
    };

    const onRightMenuButtonClick = () => {
        rightMenuClick = true;
        setRightMenuActive(true);
    };

    const onRightMenuClick = () => {
        rightMenuClick = true;
    };

    const onRightMenuActiveChange = (active) => {
        setRightMenuActive(active);
    };

    const onConfigClick = () => {
        configClick = true;
    };

    const onConfigButtonClick = (event) => {
        setConfigActive((prevState) => !prevState);
        configClick = true;
        event.preventDefault();
    };

    const onRippleChange = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onMenuButtonClick = (event) => {
        menuClick = true;

        if (isOverlay()) {
            setOverlayMenuActive((prevState) => !prevState);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive((prevState) => !prevState);
        } else {
            setStaticMenuMobileActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const onTopbarItemClick = (event) => {
        topbarItemClick = true;
        setTopbarMenuActive((prevState) => !prevState);
        hideOverlayMenu();
        event.preventDefault();
    };

    const onToggleMenu = (event) => {
        menuClick = true;

        if (overlayMenuActive) {
            setOverlayMenuActive(false);
        }

        if (sidebarActive) {
            setSidebarStatic((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarMouseOver = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setSidebarActive(isDesktop());
            setTimeout(() => {
                setPinActive(isDesktop());
            }, 200);
        }
    };

    const onSidebarMouseLeave = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setTimeout(() => {
                setSidebarActive(false);
                setPinActive(false);
            }, 250);
        }
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onChangeActiveInlineMenu = (event) => {
        setActiveInlineProfile((prevState) => !prevState);
        event.preventDefault();
    };

    const onRootMenuItemClick = () => {
        setMenuActive((prevState) => !prevState);
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            hideOverlayMenu();
            setResetActiveIndex(true);
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const isOverlay = () => {
        return menuMode === 'overlay';
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const onInputClick = () => {
        searchClick = true;
    };

    const breadcrumbClick = () => {
        searchClick = true;
        setSearchActive(true);
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const layoutClassName = classNames('layout-wrapper', {
        'layout-static': menuMode === 'static',
        'layout-overlay': menuMode === 'overlay',
        'layout-overlay-active': overlayMenuActive,
        'layout-slim': menuMode === 'slim',
        'layout-horizontal': menuMode === 'horizontal',
        'layout-active': menuActive,
        'layout-mobile-active': staticMenuMobileActive,
        'layout-sidebar': menuMode === 'sidebar',
        'layout-sidebar-static': menuMode === 'sidebar' && sidebarStatic,
        'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static',
        'p-ripple-disabled': !ripple
    });

    return (
        <div className={layoutClassName} onClick={onDocumentClick}>
            <LoadingOverlay active={isLoading} spinner text="Please Wait ...">
                <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />
                {!user ? (
                    <Routes>
                        <Route path="*" element={<LoginScreen />} />
                        <Route path="/forget-password" element={<ForgetPassword />} />
                    </Routes>
                ) : (
                    <>
                        <div className="layout-main">
                            <AppTopbar
                                items={navMenu}
                                menuMode={menuMode}
                                colorScheme={props.colorScheme}
                                menuActive={menuActive}
                                topbarMenuActive={topbarMenuActive}
                                activeInlineProfile={activeInlineProfile}
                                onTopbarItemClick={onTopbarItemClick}
                                onMenuButtonClick={onMenuButtonClick}
                                onSidebarMouseOver={onSidebarMouseOver}
                                onSidebarMouseLeave={onSidebarMouseLeave}
                                onToggleMenu={onToggleMenu}
                                onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                                onMenuClick={onMenuClick}
                                onMenuItemClick={onMenuItemClick}
                                onRootMenuItemClick={onRootMenuItemClick}
                                resetActiveIndex={resetActiveIndex}
                            />

                            <AppMenu
                                model={navMenu}
                                onRootMenuItemClick={onRootMenuItemClick}
                                onMenuItemClick={onMenuItemClick}
                                onToggleMenu={onToggleMenu}
                                onMenuClick={onMenuClick}
                                menuMode={menuMode}
                                colorScheme={props.colorScheme}
                                menuActive={menuActive}
                                sidebarActive={sidebarActive}
                                sidebarStatic={sidebarStatic}
                                pinActive={pinActive}
                                onSidebarMouseLeave={onSidebarMouseLeave}
                                onSidebarMouseOver={onSidebarMouseOver}
                                activeInlineProfile={activeInlineProfile}
                                onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                                resetActiveIndex={resetActiveIndex}
                            />

                            {/* <AppBreadcrumb
                            routes={routes}
                            onMenuButtonClick={onMenuButtonClick}
                            menuMode={menuMode}
                            onRightMenuButtonClick={onRightMenuButtonClick}
                            onInputClick={onInputClick}
                            searchActive={searchActive}
                            breadcrumbClick={breadcrumbClick}
                        /> */}

                            <div className="layout-main-content">
                                <Routes>
                                    <Route path="/" exact="true" element={<Dashboard />} />
                                    <Route path="/login" exact="false" element={<Login />} />
                                    {/* Merchant */}
                                    <Route path="/merchant-list" exact="false" element={<MerchantList />} />
                                    <Route path="/merchant-add" exact="false" element={<AddMerchant />} />
                                    <Route path="/merchant-edit" exact="false" element={<EditMerchant />} />
                                    <Route path="/merchant-view" exact="false" element={<ViewMerchant />} />
                                    {/* Merchant Approval */}
                                    <Route path="/merchant-approval-list" exact="false" element={<MerchantApprovals />} />
                                    <Route path="/merchant-approval-edit" exact="false" element={<EditMerchantApproval />} />
                                    <Route path="/merchant-approval-view" exact="false" element={<ViewMerchantApproval />} />
                                    {/* Draft Merchant */}
                                    <Route path="/draft-merchant-list" exact="false" element={<MerchantDrafts />} />
                                    <Route path="/blacklist-merchant" exact="false" element={<BlacklistMerchant />} />

                                    <Route path="/draft-merchant-edit" exact="false" element={<EditDraftMerchant />} />
                                    <Route path="/draft-merchant-view" exact="false" element={<ViewDraftMerchant />} />
                                    <Route path="/merchant-transaction-reports" exact="false" element={<MerchantTransactionReport />} />
                                    {/* <Route path="/merchant-leads" exact="false" element={<MerchantLeads />} /> */}
                                    <Route path="/merchant-withdrawal-request" exact="false" element={<MerchantWithdrawal />} />
                                    <Route path="/merchant-wallet" exact="false" element={<MerchantWallet />} />
                                    <Route path="/merchant-mock" exact="false" element={<MerchantMock />} />
                                    <Route path="/merchant-wallet-request" exact="false" element={<MerchantWalletRequest />} />
                                    <Route path="/merchant-fees" exact="false" element={<MerchantFees />} />
                                    <Route path="/gateway-list" exact="false" element={<GatewayList />} />
                                    <Route path="/collection-ledger" exact="false" element={<CollectionLedger />} />
                                    <Route path="/merchant-fee-report" exact="false" element={<MerchantFeeReport />} />
                                    <Route path="/withdrawal-report" exact="false" element={<WithdrawalReport />} />
                                    <Route path="/page-list" exact="false" element={<PageList />} />
                                    <Route path="/blog" exact="false" element={<Blog />} />
                                    <Route path="/vendor-list" exact="false" element={<ManageVendors />} />
                                    <Route path="/epos-list" exact="false" element={<ManageEPOS />} />
                                    <Route path="/language-list" exact="false" element={<ManageLanguages />} />
                                    <Route path="/whitelist" exact="false" element={<ManageWhiteList />} />
                                    <Route path="/manage-accounts" exact="false" element={<ManageAccounts />} />
                                    {/* Bank */}
                                    <Route path="/bank-list" exact="false" element={<BankList />} />
                                    {/* merchant Module Management */}
                                    <Route path="/merchant-module-management" exact="false" element={<MerchantModule />} />
                                    {/* admin Module Management */}
                                    <Route path="/admin-module-management" exact="false" element={<AdminModule />} />

                                    <Route path="/currency-list" exact="false" element={<CurrencyList />} />
                                    {/* Bill */}
                                    <Route path="/biller-list" exact="false" element={<BillerList />} />
                                    <Route path="/biller-payment" exact="false" element={<BillerPayment />} />

                                    {/* Roles */}
                                    <Route path="/roles-permissions" exact="false" element={<Roles />} />
                                    <Route path="/add-role" exact="false" element={<AddRole />} />
                                    <Route path="/edit-role" exact="false" element={<EditRole />} />
                                    <Route path="/view-role" exact="false" element={<ViewRole />} />
                                    <Route path="/users" exact="false" element={<Users />} />

                                    <Route path="/merchant-reports" exact="false" element={<MerchantReports />} />
                                    <Route path="/invoice-reports" exact="false" element={<InvoiceReports />} />
                                    {/* Customers */}
                                    <Route path="/customers" exact="false" element={<Customers />} />
                                    <Route path="/invoiceManagement" exact="false" element={<InvoiceManagement />} />
                                    {/* Profile */}
                                    <Route path="/profile" exact="false" element={<Profile />} />
                                    {/* tickets */}
                                    <Route path="/tickets" exact="false" element={<Tickets />} />
                                    <Route path="/edit-ticket" exact="false" element={<EditTicket />} />
                                    <Route path="/view-ticket" exact="false" element={<ViewTicket />} />
                                </Routes>
                            </div>

                            <AppFooter colorScheme={props.colorScheme} />
                        </div>
                    </>
                )}

                <AppRightMenu rightMenuActive={rightMenuActive} onRightMenuClick={onRightMenuClick} onRightMenuActiveChange={onRightMenuActiveChange} />

                <AppConfig
                    configActive={configActive}
                    onConfigButtonClick={onConfigButtonClick}
                    onConfigClick={onConfigClick}
                    menuMode={menuMode}
                    changeMenuMode={onMenuModeChange}
                    colorScheme={props.colorScheme}
                    changeColorScheme={props.onColorSchemeChange}
                    theme={props.theme}
                    changeTheme={props.onMenuThemeChange}
                    componentTheme={props.componentTheme}
                    changeComponentTheme={props.onComponentThemeChange}
                    ripple={ripple}
                    onRippleChange={onRippleChange}
                />
                <ToastContainer />
            </LoadingOverlay>
        </div>
    );
};

export default App;
